module.exports = __webpack_public_path__ + "img/avt.13e38be5.png";